module.exports = __webpack_public_path__ + "img/examCenterUser.c904f4ef.png";